export default "__VITE_ASSET__Cf2uFB4b__"